export default `
    <header id="#= data.id #" class="container banner-class top-banner">
        <div class="row banner">
            <div class="col col-xs-9 no-pad">
                <span class="sp-logo-gray"></span>
                <span class="banner-user-info" id="#= data.id #_UserInfo">
                    #= data.userInfo #
                </span>
            </div>
            <div class="col col-xs-3 flex-align-end no-pad">
                <div class="banner-top-utilities" id="#= data.id #_TopUtilities">
                    #= data.topUtilities #
                </div>
            </div>
        </div>
        <div class="row banner pad-t-16">
            <div class="col-xs-9 no-pad banner-nav-bar" id="#= data.id #_NavBar">
                <div class="nav-bar-tab-container">
                    <a href="/Home" id="#= data.id #_Home" class="nav-bar-tab banner-home">
                        <i class="fas fa-cog"></i>
                    </a>
                </div>
                <div class="col-xs-11 no-pad">
                    #= data.links #
                </div>
            </div>
            <div class="col-xs-3 no-pad">
                <div class="banner-bottom-utilities" id="#= data.id #_BottomUtilities">
                    #= data.bottomUtilities #
                </div>
            </div>
        </div>
    </header>
`;
